import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getEntitlements } from 'api/accessHandlerService';

export const useEntitlementsQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['entitlements', config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      const entitlements = getEntitlements(config);
      return entitlements;
    },
    placeholderData: keepPreviousData
  });

  return query;
};
